import IEmployeeInfoRepository from '../ports/outbound/IEmployerRepository';

export class EmployeeInfoUseCase {
  // Implementation of the use case methods would go here
  constructor(private repo: IEmployeeInfoRepository) { }

  async getStates() {
    return this.repo.fetchStates();
  }

  async getEmployerLocations(accountId: string) {
    return this.repo.fetchEmployerLocations(accountId);
  }

  async getStateCityByZipcode(zipcode: string) {
    return this.repo.fetchStateCityByZipcode(zipcode);
  }

  async searchAccounts(searchKey: string, signal?: AbortSignal) {
    return this.repo.searchAccounts(searchKey, signal);
  }
}
